var amdi18n={"__root":{"errorNotADashbaord":"Not a dashboard","errorDashboardCannotBeModified":"Dashboard cannot be modified","errorDashboardNotTabbed":"Dashboard is not tabbed","errorMissingModuleId":"The moduleId parameter is missing","errorUnableToLoadMetadata":"Unable to download the metadata. Verify that the provided module ID is correct","errorMissingModuleIdMetadataParameters":"The Missing moduleId and/or metadata parameters are missing","errorModuleNotYetLoaded":"No loaded Metadata found. Make sure that the Metadata is loaded before calling this function"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;